import { inject, Injectable } from "@angular/core";
import { GraphService } from "@kernel/graphql/services/graph.service";
import { CONVERSIONS_QUERY } from "@app/applications/chat/queries/conversations.query";
import { first, map, Observable } from "rxjs";
import { IPaginatedConversation } from "@app/shared/chat/interfaces/conversation.interface";
import { ListingGraphqlInput, PaginationGraphqlInput, SortGraphqlInput } from "@kernel/graphql/models";
import { CHAT_CHAT_MESSAGE_QUERY } from "@app/applications/chat/queries/chat-messages.query";
import { IPaginatedChatMessage } from "@app/shared/chat/interfaces/chat-message.interface";
import { HttpHeaders } from "@angular/common/http";
import { gql } from "apollo-angular";

@Injectable({
  providedIn: "root",
})
export class ChatApiService {
  graphService = inject(GraphService);

  getConversations(page = 1, showLoading = true): Observable<IPaginatedConversation> {
    return this.graphService
      .constructListingQuery<{
        userConversations: IPaginatedConversation;
      }>(
        [CONVERSIONS_QUERY],
        `userConversations`,
        ListingGraphqlInput.wrap(undefined, new PaginationGraphqlInput(page, 30), new SortGraphqlInput("lastActivityAt", -1)),
        null,
        !showLoading ? new HttpHeaders().set("ignore_http_loader", "ignore_http_loader") : undefined
      )
      .pipe(
        first(),
        map(result => {
          if (result.errors?.length) {
            throw result.errors[0];
          }
          return result.data.userConversations;
        })
      );
  }

  getChatMessages(conversationId: string, page = 1): Observable<IPaginatedChatMessage> {
    return this.graphService
      .constructListingQuery<{ listMessages: IPaginatedChatMessage }>(
        [CHAT_CHAT_MESSAGE_QUERY],
        `listMessages`,
        {
          ...ListingGraphqlInput.wrap(undefined, new PaginationGraphqlInput(page, 50)),
          swapRequestId: conversationId,
        },
        { swapRequestId: "String!" }
      )
      .pipe(
        first(),
        map(result => {
          if (result.errors?.length) {
            throw result.errors[0];
          }
          return result.data.listMessages;
        })
      );
  }

  getNotSeenMessagesCount() {
    return this.graphService.query<{ unseenConversationsCount: number }>({
      query: gql("query UnseenConversationsCount { unseenConversationsCount }"),
    });
  }
}
